
import { storedRef } from './utils.js';

const activity = 1;

const createPhoto = ( photo, questions ) =>

  questions.map( ( question, index ) => ( {

    question,

    id: `activity-${ activity }-photo-${ photo }-question-${ index + 1 }`,

    answer: storedRef( activity, `photo-${ photo }-answer-${ index + 1 }`, null )

  } ) );

export const photo1Questions = createPhoto( 1, [

  'Do these signs surprise you? Why or why not?',

  'If you were traveling during the time of segregation, how would these signs affect your trip?',

  'What story do you think these photos tell? What different perspectives need to be addressed in understanding the full story of these photos?'

] );

export const photo2Questions = createPhoto( 2, [

  'What is your first impression of this photo?',

  'As you look closer at the photo, notice that there are quite a few people in the photo. How might their perspectives on this event be different?',

  'Think about the perspective of the photographer. Who is he photographing and why?',

  'You probably recognize this person in the center of the photo as Dr. Martin Luther King, Jr. The photographer is Rowland Scherman. Do a bit of research on Mr. Scherman. Does knowing more about him change your perspective about this photo?',

  'The photographer captioned this photo "Dr. Martin Luther King, Jr. and Mathew Ahmann in the crowd." Do a bit of research on Mathew Ahmann. Does knowing more about him change your perspective? Why do you think Mr. Scherman named him in the caption?'

] );

export const photo3Questions = createPhoto( 3, [

  'What is your first impression of this photo?',

  'What about this day was difficult for Elizabeth? Why do you think she chose to attend Little Rock Central? What might her perspective on the event be?',

  'Look at the other students in the photo. How would you describe the emotions of each of the girls just behind Elizabeth? What about this day was difficult for them? What might their perspectives on the event be?'

] );

export const photo4Questions = createPhoto( 4, [

  'Ruby is six years old. If you were one of Ruby\'s parents, would you have made the decision to send her to William Frantz Elementary School? Why or why not?',

  'If you were one of Ruby\'s parents, what would you have told her before sending her to her first day?',

  'Look at the three men with Ruby. They are U.S. Marshals there to protect Ruby and to enforce desegregation laws. What might their perspectives on the event be? What would you do if your job required you to do something at odds with your personal beliefs?',

  'Look at the man inside the building looking through the window. What might his perspective on the event be?'

] );

export const seenPlayerDialog = storedRef( activity, 'seen-player-dialog', false );

export const seenSaveDialog = storedRef( activity, 'seen-save-dialog', false );

export const hasDownloaded = storedRef( activity, 'has-downloaded', false );
